import Link from 'next/link';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { BreadcrumbItemType } from '../../../types';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
interface BreadcrumbItemProps extends BreadcrumbItemType {
  isLast: boolean;
  position: string;
}

const BreadcrumbItem = ({
  url,
  name,
  title,
  isLast,
  position,
}: BreadcrumbItemProps) => {
  return (
    <>
      <li
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <Link href={url}>
          <a
            property="item"
            typeof="WebPage"
            itemProp="item"
            title={title}
            className={ivclass(
              'iv-font-semibold',
              'iv-block',
              'iv-text-black-50',
              'sm:iv-max-w-[200px]',
              'iv-overflow-x-hidden',
              'iv-whitespace-nowrap',
              'iv-overflow-ellipsis',
              'hover:iv-cursor-pointer',
              isLast && 'iv-pointer-events-none',
            )}
          >
            <span property="name" itemProp="name">
              {name}
            </span>
            <meta itemProp="position" content={position} />
          </a>
        </Link>
      </li>

      {isLast ? (
        ''
      ) : (
        <ImageComponent
          elementype="native"
          loading="lazy"
          width="10"
          height="24"
          src={`${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/header-icons/angle-right-bold.svg`}
          className={ivclass(
            'iv-px-2',
            'iv-inline-block',
            'group-hover:iv-hidden',
          )}
        />
      )}
    </>
  );
};

export default BreadcrumbItem;
